module.exports = __webpack_public_path__ + "static/media/goal3.e241ebda.svg";